import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './OperatorUploadFile.css';

const OPERATOR_ROOT = process.env.REACT_APP_OPERATOR_START_PATH || '/operator';

function OperatorUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={OPERATOR_ROOT}
      sessionPrefix="operator_file"
    />
  );
}

OperatorUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default OperatorUploadFile;
